import React, { PropsWithChildren, useState } from 'react';
import { Box, useMediaQuery, useTheme, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Header from '../header/Header';
import LeftMenu from '../leftmenu/LeftMenu';

import './layout.css';

const DRAWER_WIDTH = 240;

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Box className="iauto-layout-wrapper" sx={{ display: 'flex', minHeight: '100vh' }}>
            <Box
                component="header"
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: theme.zIndex.drawer + 1,
                }}
            >
                <Header />
            </Box>

            {isMobile && (
                <IconButton
                    color="primary"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{
                        position: 'fixed',
                        top: 80,
                        left: 16,
                        zIndex: theme.zIndex.drawer + 2,
                        backgroundColor: 'background.paper',
                        boxShadow: 2,
                        '&:hover': {
                            backgroundColor: 'background.paper',
                            boxShadow: 4,
                        },
                    }}
                >
                    <MenuIcon />
                </IconButton>
            )}

            <Box
                component="nav"
                sx={{
                    width: { md: DRAWER_WIDTH },
                    flexShrink: { md: 0 },
                }}
            >
                <LeftMenu
                    mobileOpen={mobileOpen}
                    onDrawerToggle={handleDrawerToggle}
                    drawerWidth={DRAWER_WIDTH}
                />
            </Box>
            <Box
                component="main"
                className="iauto-layout-content"
                sx={{
                    flexGrow: 1,
                    width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
                    minHeight: '100vh',
                    backgroundColor: 'background.default',
                    pt: '64px',
                    transition: theme.transitions.create(['margin', 'width'], {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    }),
                }}
            >
                <Box
                    sx={{
                        p: { xs: 2, sm: 3 },
                        maxWidth: '1600px',
                        margin: '0 auto',
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
};


export default Layout;
